import { Link } from "react-router-dom";
import { usePageTitle } from "@/components/layout/AppLayout";

const Page = ({ title, children, testId }) => {
    usePageTitle(title);
    return (
        <article className="mx-auto max-w-3xl px-4 sm:px-6 py-12" data-testid={testId}>
            <h1 className="text-3xl sm:text-4xl font-extrabold">{title}</h1>
            <div className="mt-6 space-y-4 text-base leading-relaxed">{children}</div>
        </article>
    );
};

export const PrivacyInfo = () => (
    <Page title="Informativa privacy" testId="privacy-info-page">
        <p>Testo provvisorio. EDI Confcommercio tratta i dati forniti in fase di registrazione (dati aziendali e del referente) per gestire l'account, erogare l'assessment sulla maturità dell'intelligenza artificiale e consentire allo sportello SPIN di riferimento di offrire supporto alla tua impresa.</p>
        <p>I dati sono conservati su server dedicati e non sono ceduti a terzi. Puoi chiederne in ogni momento l'accesso, la rettifica o la cancellazione scrivendo allo sportello SPIN di riferimento.</p>
        <p>L'utilizzo dell'assistente AI richiede un consenso separato, che puoi esprimere o revocare nella sezione "Privacy e consensi" del tuo profilo.</p>
        <p>Il testo definitivo dell'informativa sarà pubblicato da EDI Confcommercio.</p>
    </Page>
);

export const AccessibilityStatement = () => (
    <Page title="Dichiarazione di accessibilità" testId="accessibility-statement-page">
        <p>EDI Confcommercio si impegna a rendere questa piattaforma accessibile, conformemente alle Linee guida AgID sull'accessibilità degli strumenti informatici e ai requisiti WCAG 2.1 livello AA (UNI EN 301549).</p>
        <p>Tramite il pulsante "Accessibilità" presente in ogni pagina puoi aumentare la dimensione del testo, attivare l'alto contrasto, un font ad alta leggibilità, una maggiore spaziatura del testo, l'evidenziazione dei link e la riduzione delle animazioni. Le preferenze sono salvate sul tuo dispositivo.</p>
        <p>Se riscontri difficoltà nell'utilizzo della piattaforma, contatta lo sportello SPIN di riferimento.</p>
    </Page>
);

export const NotFound = () => (
    <Page title="Pagina non trovata" testId="not-found-page">
        <p>La pagina che cerchi non esiste o è stata spostata.</p>
        <Link to="/" className="btn-primary" data-testid="not-found-home-link">Torna alla home</Link>
    </Page>
);
